<template>
  <section class="content">
    <div class="row">
      <div class="col-md-12">
        <div class="nav-tabs-custom no-margin">
          <ul class="nav nav-tabs">
            <li><a :href="'/accounting/companies/' + $route.params.company_id" class="text-muted"><i class="fa fa-arrow-left mr-5"></i>{{'back' | translate}}</a></li>
            <li class="active"><a href="#basics" data-toggle="tab" aria-expanded="true">{{'basic_info' | translate}}</a></li>
            <li><a href="#addresses" data-toggle="tab" aria-expanded="false">{{ 'addresses' | translate }}</a></li>
            <li><a href="#cc_override" data-toggle="tab" aria-expanded="false">{{ 'cc_override' | translate }}</a></li>
          </ul>
        </div>
        <div class="tab-content">
          <!-- COMPANY -->
          <div class="tab-pane active" id="basics">
            <div class="row">
              <div class="col-xs-12 col-md-8">
                <div class="box box-primary">
                  <div class="box-header with-border">
                    <h5 class="no-margin"><i class="fa fa-cogs text-muted mr-5"></i>{{'basic_info' | translate}}:</h5>
                  </div>
                  <div class="box-body">
                    <div class="row">
                      <div class="col-md-8 border-right">
                        <div class="form-group">
                          <i class="fa fa-spinner fa-spin" v-if="loading"></i>
                          <label for="shop_name">{{'shop_name' | translate}}</label>
                          <input class="form-control"  v-validate="{required: true}" :disabled="loading" data-vv-scope="basicAddress" id="shop_name" :placeholder="'shop_name' | translate" type="text" v-model="storeData.name">
                        </div>
                        <div class="form-group">
                          <i class="fa fa-spinner fa-spin" v-if="loading"></i>
                          <label for="contact_name">{{'contact_name' | translate}}</label>
                          <input class="form-control"  v-validate="{required: true}" :disabled="loading" data-vv-scope="basicAddress" id="contact_name" :placeholder="'contact_name' | translate" type="text" v-model="storeData.contact_name">
                        </div>
                        <div class="row">
                          <div class="col-sm-9 col-xs-12">
                            <div class="form-group">
                              <i class="fa fa-spinner fa-spin" v-if="loading"></i>
                              <label for="street">{{'street' | translate}}</label>
                              <input class="form-control"  v-validate="{required: true}" :disabled="loading" data-vv-scope="basicAddress" id="street" :placeholder="'street' | translate" type="text" v-model="storeData.street">
                            </div>
                          </div>
                          <div class="col-sm-3 col-xs-12">
                            <div class="form-group">
                              <i class="fa fa-spinner fa-spin" v-if="loading"></i>
                              <label for="street_number">Nr.:</label>
                              <input class="form-control"  v-validate="{required: true}" :disabled="loading" data-vv-scope="basicAddress" id="street_number" placeholder="Nr.:" type="text" v-model="storeData.street_no">
                            </div>
                          </div>
                          <div class="col-sm-4 col-xs-12">
                            <div class="form-group">
                              <i class="fa fa-spinner fa-spin" v-if="loading"></i>
                              <label for="zip_code">{{'zip_code' | translate}}</label>
                              <input class="form-control"  v-validate="{required: true}" :disabled="loading" data-vv-scope="basicAddress" id="zip_code" :placeholder="'zip_code' | translate" type="text" v-model="storeData.zip_code">
                            </div>
                          </div>
                          <div class="col-sm-8 col-xs-12">
                            <div class="form-group">
                              <i class="fa fa-spinner fa-spin" v-if="loading"></i>
                              <label for="city">{{'city' | translate}}</label>
                              <input class="form-control"  v-validate="{required: true}" :disabled="loading" id="city" data-vv-scope="basicAddress" :placeholder="'city' | translate" type="text" v-model="storeData.city">
                            </div>
                          </div>
                        </div>
                        <hr>
                        <div class="form-group">
                          <i class="fa fa-spinner fa-spin" v-if="loading"></i>
                          <label for="contact_phone">{{'contact_phone' | translate}}</label>
                          <input class="form-control"  v-validate="{required: true}" :disabled="loading" id="contact_phone" data-vv-scope="basicAddress" :placeholder="'contact_phone' | translate" type="text" v-model="storeData.contact_phone">
                        </div>
                        <div class="form-group">
                          <i class="fa fa-spinner fa-spin" v-if="loading"></i>
                          <label for="contact_email">{{'contact_email' | translate}}</label>
                          <input class="form-control"  v-validate="{required: true}" :disabled="loading" id="contact_email" data-vv-scope="basicAddress" :placeholder="'contact_email' | translate" type="text" v-model="storeData.contact_email">
                        </div>
                        <div class="form-group">
                          <i class="fa fa-spinner fa-spin" v-if="loading"></i>
                          <label for="contact_email">{{'order_email' | translate}}</label>
                          <input type="text" class="form-control"  v-validate="{required: true}" :disabled="loading" data-vv-scope="basicAddress" id="order_email" :placeholder="'contact_email' | translate" v-model="storeData.order_email">
                        </div>
                        <div class="col-xs-12">
                          <span v-show="errors.any()" class="text-danger pull-right">{{ 'all_fields_required' | translate }}</span><br>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <i class="fa fa-spinner fa-spin" v-if="loading"></i>
                          <label for="erp_store_id">{{'erp_store_id' | translate}}</label>
                          <input type="text" class="form-control" v-validate="{required: true}" :disabled="loading" data-vv-scope="basicAddress" id="erp_store_id" :placeholder="'erp_store_id' | translate" v-model="storeData.erp_store_id">
                        </div>
                        <div class="form-group">
                          <i class="fa fa-spinner fa-spin" v-if="loading"></i>
                          <label for="sap_number">SAP-{{'number' | translate}}</label>
                          <input class="form-control" :disabled="loading" id="sap_number"  v-validate="{required: true}" data-vv-scope="basicAddress" :placeholder="'number' | translate" type="text" v-model="storeData.sap_number">
                        </div>
                        <div class="form-group">
                          <i class="fa fa-spinner fa-spin" v-if="loading"></i>
                          <label for="sap_number">GLN</label>
                          <input class="form-control" :disabled="loading"  v-validate="{required: true}" id="gln" data-vv-scope="basicAddress" placeholder="GLN" type="text" v-model="storeData.gln">
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="box-footer">
                    <button @click="updateBasicData()" :disabled="errors.any('basicAddress')" class="btn btn-success btn-sm"><i class="fa fa-save mr-5"></i>{{'save_settings' | translate}}</button>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-md-4">
                <div class="box box-primary" v-if="sde1Active">
                  <div class="box-header with-border">
                    <h5 class="no-margin"><i class="fa fa-map-marker text-muted mr-5"></i> {{'cnc_configuration' | translate}}:</h5>
                  </div>
                  <div class="box-body">
                    <div class="form-group no-margin">
                      <label for="reservation_email">{{'cnc_reservation_email' | translate}}</label>
                      <input class="form-control" :disabled="loading" id="reservation_email" :placeholder="'cnc_reservation_email' | translate" type="text" v-model="storeData.reservation_email">
                    </div>
                  </div>
                  <div class="box-footer">
                    <button @click="updateReservationEmail()" class="btn btn-success btn-block btn-sm"><i class="fa fa-save mr-5"></i>{{'click_and_collect_update' | translate}}</button>
                  </div>
                </div>
                <div class="box box-primary">
                  <div class="box-header with-border">
                    <h5 class="no-margin"><i class="fa fa-map-marker text-muted mr-5"></i>{{'shipcloud_key_configuration' | translate}}:</h5>
                  </div>
                  <div class="box-body">
                    <div class="form-group no-margin">
                      <label for="reservation_email">{{'shipcloud_key' | translate}}</label>
                      <input class="form-control" :disabled="loading" id="shipcloud_key" placeholder="shipcloud_key" type="text" v-model="storeData.shipcloud_key">
                    </div>
                  </div>
                  <div class="box-footer">
                    <button @click="updateShipcloudKey()" class="btn btn-success btn-block btn-sm">{{'shipcloud_key_update' | translate}}</button>
                  </div>
                </div>
                <div class="box box-primary">
                  <div class="box-header with-border">
                    <h5 class="no-margin"><i class="fa fa-map-marker text-muted mr-5"></i>{{'store_message_note' | translate}}:</h5>
                  </div>
                  <div class="box-body">
                    <div class="form-group no-margin">
                      <label for="store_message">{{'message_note' | translate}}:</label>
                      <textarea class="form-control" :disabled="loading" v-validate="{ regex: /^.{0,255}$/}" id="store_message" :placeholder="'store_message' | translate" type="text" name="store" v-model="storeData.message"></textarea>
                      <span v-show="errors.has('store')" class="small text-danger">{{ 'note_text_validation' | translate }}</span>
                    </div>
                  </div>
                  <div class="box-footer">
                    <button @click="postMessage()" :disabled="errors.has('store')" class="btn btn-success pull-right">{{'note_text_update' | translate}}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="tab-pane" id="addresses">
            <div class="row">
              <span v-for="i in [sendAddress,returnAddress,pickupAddress]" v-bind:key="i.id" >
              <store-adresses @sendDataToParent = postDataForReturnShipping($event) :address="storeData" :prefix = "i"></store-adresses>
                </span>
            </div>
            </div>
          <div class="tab-pane" id="cc_override">
            <div class="row">
              <div class="col-xs-12">
                <div class="box box-primary">
                  <div class="box-header with-border">
                    <h5 class="no-margin"><i class="fa fa-cogs text-muted mr-5"></i>{{'cc_override' | translate}}:</h5>
                  </div>
                  <div class="box-body">
                    <div class="row">
                      <div class="border-right">
                        <div class="form-group">
                          <i class="fa fa-spinner fa-spin" v-if="loading"></i>
                          <label for="shop_name">{{'shop_name' | translate}}</label>
                          <input class="form-control"  v-validate="{required: true}" :disabled="loading" data-vv-scope="basicAddress" id="shop_name" :placeholder="'shop_name' | translate" type="text" v-model="storeData.name">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import StoreAdresses from "./StoreAdresses";
import {sde1Active} from '@/sunset-helper'
export default {
  components: {StoreAdresses},
  props: ['storeData', 'loading'],
  data () {
    return {
      sendAddress : 'shipping',
      returnAddress : 'return',
      pickupAddress : 'pickup'
    }
  },
  computed: {
    sde1Active
  },
  methods: {
    updateShipcloudKey() {
      API.put(`accounting/companies/${this.$route.params.company_id}/stores/${this.storeData.id}/shipcloudKey`, {"shipcloud_key": this.storeData.shipcloud_key})
        .then(response => {
          this.$emit('alert', response)
        })
        .catch(error => {
          this.$emit('alert', error)
        })
    },
    updateReservationEmail() {
      if (!this.sde1Active) return
      API.put(`accounting/companies/${this.$route.params.company_id}/stores/${this.storeData.id}/reservationEmail`, {"reservation_email": this.storeData.reservation_email})
        .then(response => {
          this.$emit('alert', response)
        })
        .catch(error => {
          this.$emit('alert', error)
        })
    },
    updateBasicData() {
      let data = {
        'name': this.storeData.name,
        'contact_name': this.storeData.contact_name,
        'street': this.storeData.street,
        'street_no': this.storeData.street_no,
        'zip_code': this.storeData.zip_code,
        'city': this.storeData.city,
        'contact_phone': this.storeData.contact_phone,
        'contact_email': this.storeData.contact_email,
        'order_email': this.storeData.order_email,
        'erp_store_id': this.storeData.erp_store_id,
        'sap_number': this.storeData.sap_number,
        'gln': this.storeData.gln
      }
      this.$validator.validate()
        .then(() => {
            if (!this.errors.any('basicAddress')) {
              this.postData(data);
            }
          }
        )
    },
    postDataForReturnShipping(address) {
      let data =
        {
          [address.prefix + '_name']: address[address.prefix + '_name'],
          [address.prefix + '_street']: address[address.prefix+ '_street'],
          [address.prefix  + '_street_no']: address[address.prefix  + '_street_no'],
          [address.prefix  + '_zip_code']: address[address.prefix  + '_zip_code'],
          [address.prefix  + '_city']: address[address.prefix  + '_city'],
          [address.prefix  + '_country']: address[address.prefix  + '_country']
        }
      if (address.prefix === 'pickup') {
        data['pickup_phone'] = address['pickup_phone']
      }
      this.postData(data);
    },
    postData(data) {
            let url = `accounting/companies/${this.$route.params.company_id}/stores/${this.storeData.id}`
            API.put(url, data)
              .then(response => {
                this.$emit('alert', response)
              })
              .catch(error => {
                this.$emit('alert', error)
              })
          },
    postMessage() {
      let url = `accounting/companies/${this.$route.params.company_id}/stores/${this.storeData.id}`
      API.put(url, {"message": this.storeData.message})
        .then(response => {
          this.$emit('alert', response)
        })
        .catch(error => {
          this.$emit('alert', error)
        })
    }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/tools/StoreEdit.vue